import React from "react";
import './Header.css'
import AppLogo from '../../../Assets/TailingStyleCenter.png'
import NipponLogo from '../../../Assets/Nippon_Taglines_N_Symbol.png'

function Header() {
    return (
        <div className="topbar">
            <h1 className="current" style={{marginTop: "10px",height:"100%",width:"100%",display:"flex",justifyContent:'space-between',alignItems:'center'}}>
            <div className="AppLogo"><img src={AppLogo} style={{ width: '160px', marginTop: '-28px'}} /></div>
            <div className="NipponLogo"><img src={NipponLogo} style={{ width: '130px', marginTop: '0px' }} /></div>
            </h1>
        </div>
    )
}
export default Header;